import CableIcon from '@mui/icons-material/Cable'
import McpServerList from './McpServerList'
import McpServerCreate from './McpServerCreate'
import McpServerShow from './McpServerShow'
import McpServerEdit from './McpServerEdit'

export default {
  list: McpServerList,
  create: McpServerCreate,
  show: McpServerShow,
  edit: McpServerEdit,
  icon: CableIcon,
}
